import DoubleChevronIcon from "./double-chevron-icon"
import SortArrowIcon from "./sort-arrow-icon"

const SortIcon = ({ direction = "none" }) => {
  return (
    <span className="ml-1 inline-flex items-center justify-center w-3 h-3">
      {direction === "none" && <DoubleChevronIcon className="text-gray-200" />}
      {direction === "asc" && <SortArrowIcon className="text-white rotate-180" />}
      {direction === "desc" && <SortArrowIcon className="text-white" />}
    </span>
  )
}

export default SortIcon
